import React from 'react';
import { useIntl } from 'react-intl';
import CloseIcon from '@mui/icons-material/Close';
import {
  HeaderContainer,
  IconContainer,
  ContentContainer,
  ContentText,
  StyledDialog,
  StyledDialogTitle,
} from './styles';
import { pyxirRocket } from 'Assets/img/home-option-icons';
import { AppMigrationNotificationModalModuleStore } from './AppMigrationNotificationModalModuleStore';

function AppMigrationNotificationModal() {
  const intl = useIntl();
  const store = AppMigrationNotificationModalModuleStore.Instance().Use();
  const isOpen = store.IsOpen;

  function onClose() {
    store.close();
  }

  return (
    <>
      <StyledDialog open={isOpen}>
        <HeaderContainer>
          <img
            src={pyxirRocket}
            alt={intl.formatMessage({ id: 'image.pyxir.portrait' })}
            style={{ width: '50px', margin: '10px' }}
          />
          <StyledDialogTitle>{intl.formatMessage({ id: 'modal.app-migration-notification.title' })}</StyledDialogTitle>
          <IconContainer>
            <CloseIcon
              role="button"
              aria-label={intl.formatMessage({ id: 'button.close' })}
              onClick={onClose}
              fontSize="large"
              sx={{ margin: '5px' }}
            />
          </IconContainer>
        </HeaderContainer>
        <ContentContainer>
          <ContentText>{intl.formatMessage({ id: 'modal.app-migration-notification.content-1' })}</ContentText>
          <ContentText>{intl.formatMessage({ id: 'modal.app-migration-notification.content-2' })}</ContentText>
        </ContentContainer>
      </StyledDialog>
    </>
  );
}

export default AppMigrationNotificationModal;
